import { enumElementBorderStyle, kDoubleBorderWidthAdder } from "../constants";
import { ThicknessAdjuster } from "./ThicknessAdjuster";

export function CalcBorderWidth(borderStyle, borderThickness, floorIt) {
  //var borderWidth = borderThickness;
  //var borderSize = Math.floor(borderWidth/2) + ThicknessAdjuster(borderWidth);
  var borderSize = borderThickness + ThicknessAdjuster(borderThickness);
  switch (borderStyle) {
    case enumElementBorderStyle.noBorder:
      borderSize = 0;
      break;
    case enumElementBorderStyle.singleBorder:
      break;
    case enumElementBorderStyle.doubleBorder:
      borderSize = borderSize + kDoubleBorderWidthAdder + 1; // The border is 1 pixel thick
      break;
  }

  if (floorIt) borderSize = Math.floor(borderSize);
  return borderSize;
}
